export default "__VITE_ASSET__CADbPzYR__"